import { Form, Formik } from "formik";
import React, { FC, ReactElement, useState } from "react";
import { useSelector } from "react-redux";
import { useGlobalState } from "../../../../Providers";
import { DEFAULT_WIDGET, QUICK_ENROLL_BKGCOLOR, SHORTCUT_SETTING_ID, UI_ELEMENT_SELECT_MENU_ITEM, WIDGET_TYPES } from "../../../../constants/widget-constants";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { useLocale } from "../../../../contexts/localeContext";
import { Widget } from "../../../../models/Widget";
import WizardSideBarStep from "../../../../models/WizardSideBarStep";
import { showError } from "../../../../services/utilities/ServiceError";
import { storeWidget } from "../../../../services/widgetService";
import { IAppState } from "../../../../store/types";
import Wizard from "../../../wizard/wizard";
import ColorStep from "../../color-step";
import MenuStep from "./menu-step";
import SummaryStep from "./summary-step";
import { toast } from "react-toastify";

interface ShortcutWizardProps {
    onClose: () => void;
}

const ShortcutWizard: FC<ShortcutWizardProps> = ({ onClose }) => {
    const user = useSelector((state: IAppState) => (state.userInfo));
    const initialItem: Widget = {
        x: DEFAULT_WIDGET.X_POSITION,
        y: DEFAULT_WIDGET.Y_POSITION,
        width: 0,
        height: 0,
        type: WIDGET_TYPES.SHORTCUT_WIDGET,
        settingIdToCopy: SHORTCUT_SETTING_ID.toString(),
        userLoginId: user.id,
        titleBackgroundColor: DEFAULT_WIDGET.TITLE_BKGCOLOR,
        titleForegroundColor: DEFAULT_WIDGET.TITLE_FGCOLOR,
        foregroundColor: DEFAULT_WIDGET.FOREGROUND_COLOR,
        id: 0,
        relationships: [],
    }
    const { translate } = useLocale();
    const [step, setStep] = useState<number>(0);
    const [selectedMenu, setSelectedMenu] = useState<string>(translate.byKey(TranslationKeys.pending));
    const { setRefreshDashboard } = useGlobalState() ?? {};
    
    const steps: WizardSideBarStep[] = [
        {
            title: translate.byKey(TranslationKeys.menu),
            description: selectedMenu,
            substeps: []
        },
        {
            title: translate.byKey(TranslationKeys.widgetConfig),
            description: '',
            substeps: []
        },
        {
            title: translate.byKey(TranslationKeys.summary),
            description: '',
            substeps: []
        }
    ];

    const onNext = () => {
        setStep(step + 1);
    }

    const onBack = () => {
        setStep(step - 1);
    }

    const content: ReactElement[] = [
        <MenuStep onNext={onNext} setSelectedMenu={setSelectedMenu} />,
        <ColorStep onNext={onNext} onBack={onBack} />,
        <SummaryStep onBack={onBack} selectedMenu={selectedMenu} />
    ];


    const onSave = (values: any) => {
        const widget: Widget = {
            ...initialItem,
            titleBackgroundColor: values.titleBackgroundColor,
            titleForegroundColor: values.titleForegroundColor,
            relationships: [
                {
                    eSysnameLookup: UI_ELEMENT_SELECT_MENU_ITEM,
                    sdValstring: values.menuId
                },
                {
                    eSysnameLookup: QUICK_ENROLL_BKGCOLOR,
                    sdValstring: values.foregroundColor
                }
            ]
        };
        
        storeWidget(widget).then(() => {
            setRefreshDashboard && setRefreshDashboard(true);
            onClose();
        }).catch((error) => {
            showError(error, toast.warn);
        });
    }

    return <Formik
        enableReinitialize={true}
        initialValues={initialItem}
        onSubmit={onSave}>
        <Form>
            <Wizard
                name={translate.byKey(TranslationKeys.shortcut)}
                step={step}
                onClose={onClose}
                sidebarSteps={steps}>
                {content}
            </Wizard>
        </Form>
    </Formik>
}

export default ShortcutWizard;